import React, { useEffect, useState } from "react";
  import { useTables } from "../../../../../../../../context/OrderCreator/TablesContext";
  import OrderInfoCard from "./OrderInfoCard";
  import OrderItemsList from "./OrderItemsList";
  import EditOrderForm from "../OrderActions/EditOrderForm";
  import EditItemModal from "../ItemsActions/EditItemModal";
  import MoveItemModal from "../ItemsActions/MoveItemModal";
  import { Button, IconButton, Menu, MenuItem, Box, Grid, Stack, useTheme, useMediaQuery } from "@mui/material";
  import Snackbar from "@mui/material/Snackbar";
  import Alert from "@mui/material/Alert";
  import KitchenIcon from "@mui/icons-material/Kitchen";
  import { useOrder } from "../../../../../../../../context/OrderCreator/TablesContext/OrderContext";
  import { usePermissions } from "../../../../../../../../context/PermissionsAndFeatures/UserPermissionsContext";
  import { useFeatures } from "../../../../../../../../context/PermissionsAndFeatures/FeaturesContext";
  import { useSettings } from "../../../../../../../../context/SettingsContext"; // NEW: read settings
  import { changeOrderItemStatus as changeOrderItemStatusApi } from "../../../../../../../../services/Settings/Orderprocessing"; // ADD: import API service to change item status
  import { handleBrowserPrint } from "../../../../../../../../components/PagesComponents/PosSection/PrintTemplates/Taghez/printUtilsTaghez"; // ✅ استيراد دالة الطباعة
  import { makeItemsInPreparation, printItems } from "../../../../../../../../services/Settings/printers"; // NEW: استيراد دالة وضع العناصر قيد التجهيز و دالة الطباعة للباك اند

  
  const OrderDetailsFetcher = ({
    orderId,
    onReload,
    onClose,
    onOrderDeleted,
  }) => {
    const theme = useTheme();
  
    // ✅ كشف دقيق لجميع مقاسات التابلت والـ iPad
    const isXSmallTablet = useMediaQuery("(min-width: 600px) and (max-width: 767px)");
    const isSmallTablet = useMediaQuery("(min-width: 768px) and (max-width: 834px)");
    const isMediumTablet = useMediaQuery("(min-width: 835px) and (max-width: 1024px)");
    const isLargeTablet = useMediaQuery("(min-width: 1025px) and (max-width: 1366px)");
    const isPortrait = useMediaQuery("(orientation: portrait)");
    const isLandscape = useMediaQuery("(orientation: landscape)");
  
    // ✅ حساب الأحجام والمسافات ديناميكياً
    const getButtonSize = () => {
      if (isXSmallTablet) return "small";
      if (isSmallTablet) return "medium";
      return "medium";
    };
  
    const getSpacing = () => {
      if (isXSmallTablet) return isPortrait ? 1.5 : 2;
      if (isSmallTablet) return isPortrait ? 2 : 2.5;
      if (isMediumTablet) return isPortrait ? 2.5 : 3;
      return 3;
    };
  
    const getPadding = () => {
      if (isXSmallTablet) return isPortrait ? 1.5 : 2;
      if (isSmallTablet) return isPortrait ? 2 : 2.5;
      if (isMediumTablet) return isPortrait ? 2.5 : 3;
      return 3;
    };
  
    const getFontSize = () => {
      if (isXSmallTablet) return { button: 13, title: 16 };
      if (isSmallTablet) return { button: 14, title: 17 };
      if (isMediumTablet) return { button: 15, title: 18 };
      return { button: 15, title: 18 };
    };
  
    const getIconSize = () => {
      if (isXSmallTablet) return { width: 40, height: 40, fontSize: 20 };
      if (isSmallTablet) return { width: 44, height: 44, fontSize: 22 };
      if (isMediumTablet) return { width: 48, height: 48, fontSize: 24 };
      return { width: 48, height: 48, fontSize: 24 };
    };
  
    const shouldStackVertically =
      (isXSmallTablet && isPortrait) ||
      (isSmallTablet && isPortrait);
  
    const buttonSize = getButtonSize();
    const spacing = getSpacing();
    const padding = getPadding();
    const fontSize = getFontSize();
    const iconSize = getIconSize();

    const {
      orderDetails,
      loadOrder,
      deleteItem,
      updateItem,
      moveItem,
      removeOffer,
      deleteOrder, // ✅ إضافة deleteOrder
      loading,
      error,
    } = useOrder();

    // NEW: read settings to check preparation_casher_button
    const { settings = {}, loading: settingsLoading } = useSettings() || {};
    const preparationCasherEnabled = settings?.preparation_casher_button === 0 || settings?.preparation_casher_button === "0";

    const [editOpen, setEditOpen] = useState(false);
    const [editData, setEditData] = useState(null);
    const [successMsg, setSuccessMsg] = useState("");
    const [itemEditOpen, setItemEditOpen] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [moveModalOpen, setMoveModalOpen] = useState(false);
    const [selectedMoveItem, setSelectedMoveItem] = useState(null);
    const [kitchenMenuAnchor, setKitchenMenuAnchor] = useState(null);
    const [sentItems, setSentItems] = useState([]);
    const { tables, loading: tablesLoading, error: tablesError, refresh: refreshTables } = useTables();
    const { hasPermission } = usePermissions();
    // feature flag for printing control
    const { hasFeature, featuresLoading } = useFeatures();
    const printingEnabled = !featuresLoading && hasFeature("printing_control");




    // ✅ تحميل تفاصيل الأوردر من الـ Context
    useEffect(() => {
      if (orderId) loadOrder(orderId);
    }, [orderId, loadOrder]);

    // ✅ تحديث عند الطلب من parent
    useEffect(() => {
      if (onReload) onReload(() => loadOrder(orderId));
    }, [onReload, orderId, loadOrder]);

    // ✅ useEffect لإضافة اختصار F9 لطباعة التجهيز
    useEffect(() => {
      const handleKeyDown = (e) => {
        // التحقق من F9 (keyCode 120)
        if (e.key === 'F9' || e.keyCode === 120) {
          e.preventDefault(); // منع السلوك الافتراضي
          if (
            hasPermission("orders_tables_print_preparation_table") &&
            printingEnabled &&
            pendingItems.length > 0
          ) {
            handlePrintPreparation();
          }
        }
      };

      // إضافة المستمع
      window.addEventListener('keydown', handleKeyDown);

      // تنظيف المستمع عند unmount
      return () => {
        window.removeEventListener('keydown', handleKeyDown);
      };
    }, [
      hasPermission,
      printingEnabled,
      orderDetails,
      settings,
    ]);

    const handleDeleteItem = async (itemId) => {
      if (!orderDetails) return alert("❌ لا توجد تفاصيل للطلب حالياً.");

      // إيجاد العنصر في تفاصيل الأوردر باستخدام المعرف (للتوافق مع OrderItemsList الحالي)
      const item = orderDetails.items?.find((i) => String(i.id) === String(itemId));
      if (!item) return alert("❌ لم يتم العثور على الصنف للحذف.");

      if (!window.confirm("❗ هل تريد حذف هذا الصنف من الطلب؟")) return;

      try {
        if (item.is_offer === 1) {
          // إذا كان العنصر عرضاً استعمل removeOffer من الـ Context
          await removeOffer({ order_id: orderDetails.id, offer_id: item.id });
          setSuccessMsg("✅ تم حذف العرض من الطلب بنجاح");
        } else {
          // صنف عادي: حذف عبر deleteItem
          await deleteItem(item.id);
          setSuccessMsg("✅ تم حذف الصنف بنجاح");
        }

        // 🔔 إشعار للـ TablesSection
        window.dispatchEvent(
          new CustomEvent("orderUpdated", {
            detail: { orderId, tableId: orderDetails.table_id },
          })
        );
      } catch (err) {
        alert(err.message || "❌ فشل في حذف الصنف / العرض");
      }
    };

    const handleUpdateItem = async (updatedData) => {
      try {
        await updateItem(updatedData);
        setSuccessMsg("✅ تم تعديل بيانات الصنف بنجاح");
        setItemEditOpen(false);

        // 🔔 إشعار
        window.dispatchEvent(
          new CustomEvent("orderUpdated", {
            detail: { orderId, tableId: orderDetails.table_id },
          })
        );
      } catch (err) {
        alert(err.message || "❌ فشل في تعديل الصنف");
      }
    };

    const handleMoveItem = async (data) => {
      try {
        await moveItem(orderId, data);
        setSuccessMsg("✅ تم نقل الصنف بنجاح");
        setMoveModalOpen(false);

        // 🔔 إشعار
        window.dispatchEvent(
          new CustomEvent("orderUpdated", {
            detail: { orderId, tableId: orderDetails.table_id },
          })
        );

        // الكود القديم بتاع تحديث الطاولة المستهدفة:
        if (typeof window.updateTableData === "function") {
          window.updateTableData(parseInt(data.target_table));
        }
      } catch (err) {
        alert(err.message || "❌ فشل في نقل الصنف");
      }
    };

    // NEW: prepare item handler — يغير حالة العنصر إلى "preparing" (يمكن تعديل الحالة المطلوبة حسب API)
    const handlePrepareItem = async (item) => {
      if (!item) return;
      if (!window.confirm(`هل تريد وضع الصنف "${item.product_name || item.name || item.id}" في حالة التجهيز؟`)) return;
      try {
        // نفترض أن updateItem يتلقى كائن يحتوي على id وحقول للتعديل
        await updateItem({ id: item.id, status: "preparing" });
        setSuccessMsg("✅ تم وضع الصنف قيد التجهيز");
        // إشعار للأجزاء الأخرى بالتحديث
        window.dispatchEvent(
          new CustomEvent("orderUpdated", {
            detail: { orderId, tableId: orderDetails.table_id },
          })
        );
      } catch (err) {
        alert(err.message || "❌ فشل في وضع الصنف قيد التجهيز");
      }
    };

    // NEW: changeOrderItemStatus(id) — يستعمله OrderItemsList لإرسال المعرف فقط
    const changeOrderItemStatus = async (itemId) => {
      if (!itemId) return;
      if (!orderDetails) return alert("❌ لا توجد تفاصيل للطلب حالياً.");
      const item = orderDetails.items?.find((i) => String(i.id) === String(itemId));
      if (!item) return alert("❌ لم يتم العثور على الصنف.");
      if (!window.confirm(`هل تريد وضع الصنف "${item.product_name || item.name || item.id}" قيد التجهيز؟`)) return;

      try {
        // حاول استدعاء دالة الـ API أولاً، إن لم تكن موجودة استخدم updateItem كـ fallback
        if (typeof changeOrderItemStatusApi === "function") {
          // استدعاء الـ API — بعض الـ APIs قد تتوقع المعرف فقط أو كـ كائن، استخدم المعرف مباشرة
          await changeOrderItemStatusApi(itemId);
        } else {
          await updateItem({ id: itemId, status: "preparing" });
        }

        setSuccessMsg("✅ تم وضع الصنف قيد التجهيز");
        window.dispatchEvent(
          new CustomEvent("orderUpdated", {
            detail: { orderId, tableId: orderDetails.table_id },
          })
        );
      } catch (err) {
        alert(err.message || "❌ فشل في تغيير حالة الصنف");
      }
    };

    // NEW: معالج طباعة التجهيز - يختار بين automatic و manuel حسب settings.printing_method
const handlePrintPreparation = async () => {
  if (!orderDetails) return alert("❌ لا توجد بيانات للطلب.");
  if (pendingItems.length === 0) return alert("❌ لا توجد أصناف قيد التجهيز للطباعة.");

  const printingMethod = (settings?.printing_method || "").toLowerCase();

  try {
    const grouped = groupItemsByKitchen(pendingItems);
    const kitchenGroups = Object.values(grouped);

    const afterMark = async () => {
      try {
        await loadOrder(orderId, true);
      } catch (e) {
        console.warn("⚠️ فشل تحديث تفاصيل الأوردر بعد تغيير الحالة:", e);
      }
      window.dispatchEvent(
        new CustomEvent("orderUpdated", {
          detail: { orderId, tableId: orderDetails?.table_id },
        })
      );
    };

    // ✅ هنجمّع كل ids اللي اتطبعت (اختياري)
    const allPrintedIds = [];

    // ✅ اطبع مجموعة مجموعة (كل مطبخ لوحده)
    for (const group of kitchenGroups) {
      const itemsForKitchen = group.items;
      const idsForKitchen = itemsForKitchen.map((it) => it.id).filter(Boolean);

      // لو مفيش ids skip
      if (idsForKitchen.length === 0) continue;

      if (printingMethod === "manuel" || printingMethod === "manual") {
        // ✅ طباعة باك-إند لكل مطبخ لوحده
        await printItems(idsForKitchen);
      } else {
        // ✅ طباعة المتصفح لكل مطبخ لوحده
        // (اختياري) ابعت kitchen_name للتمبليت لو هتضيفه فوق
        await handleBrowserPrint({
          order: {
            ...orderDetails,
            _kitchen_name: group.kitchen_name,   // optional helper field
            _kitchen_id: group.kitchen_id,       // optional helper field
          },
          items: itemsForKitchen,
        });
      }

      allPrintedIds.push(...idsForKitchen);
    }

    // ✅ بعد ما نخلص كل المطابخ: نغيّر الحالة لكل اللي اتطبع
    const uniqueIds = Array.from(new Set(allPrintedIds));
    if (uniqueIds.length > 0) {
      await makeItemsInPreparation(uniqueIds);
      await afterMark();
    }

    setSuccessMsg("✅ تم طباعة الأصناف منفصلة لكل مطبخ وتم وضعها قيد التجهيز");
  } catch (err) {
    console.error("❌ خطأ في معالج طباعة التجهيز:", err);
    alert(err?.message || "❌ حدث خطأ أثناء طباعة التجهيز");
  }
};

    const groupItemsByKitchen = (items = []) => {
      return items.reduce((acc, item) => {
        const key = item?.kitchen_id ?? "no_kitchen";
        if (!acc[key]) acc[key] = { kitchen_id: key, kitchen_name: item?.kitchen_name || "بدون مطبخ", items: [] };
        acc[key].items.push(item);
        return acc;
      }, {});
    };

    // ✅ معالج حذف الأوردر بالكامل
    const handleDeleteOrder = async () => {
      if (!orderDetails) return alert("❌ لا توجد تفاصيل للطلب حالياً.");
      
      if (!window.confirm("❗ هل أنت متأكد من حذف الطلب بالكامل؟")) return;

      try {
        await deleteOrder(orderDetails.id);
        setSuccessMsg("✅ تم حذف الطلب بنجاح");
        
        // 🔔 إشعار للـ TablesSection
        window.dispatchEvent(
          new CustomEvent("orderUpdated", {
            detail: { orderId, tableId: orderDetails.table_id },
          })
        );

        // استدعاء callback من parent
        if (onOrderDeleted) onOrderDeleted();
        if (onClose) onClose();
      } catch (err) {
        alert(err.message || "❌ فشل في حذف الطلب");
      }
    };

    if (loading) return <Box sx={{ py: 2, textAlign: "center", color: "text.secondary" }}>جاري تحميل التفاصيل...</Box>;
    if (error) return <Box sx={{ py: 2, textAlign: "center", color: "error.main" }}>❌ {error}</Box>;
    if (!orderDetails) return null;

    const pendingItems =
      orderDetails?.items?.filter((item) => item.status === "pending") || [];

    return (
      <Box
        sx={{
          background: "linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)",
          border: "1px solid rgba(251, 194, 235, 0.1)",
          p: padding,
          borderRadius: { xs: 2, sm: 2.5, md: 3 },
          boxShadow: "0 8px 32px rgba(0, 0, 0, 0.3)",
          mb: spacing,
          overflow: "hidden",
        }}
      >
        <Grid
          container
          spacing={spacing}
          sx={{
            flexDirection: shouldStackVertically ? "column" : "row",
          }}
        >
          <Grid
            item
            xs={12}
            sm={shouldStackVertically ? 12 : 6}
            sx={{
              mb: shouldStackVertically ? spacing : 0,
            }}
          >
            <OrderInfoCard
              details={orderDetails}
              onEdit={(data) => {
                setEditData({
                  ...data,
                  order_id: orderDetails.id,
                  customer_id: orderDetails.customer?.id || "",
                  customer_phone1: orderDetails.customer?.phone1 || "",
                  customer_phone2: orderDetails.customer?.phone2 || "",
                  customer_phone3: orderDetails.customer?.phone3 || "",
                  customer_address1: orderDetails.customer?.address1 || "",
                  customer_address2: orderDetails.customer?.address2 || "",
                });
                setEditOpen(true);
              }}
              tables={tables}
              onDelete={handleDeleteOrder}
            />
          </Grid>

          <Grid
            item
            xs={12}
            sm={shouldStackVertically ? 12 : 6}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: shouldStackVertically ? "center" : "flex-end",
            }}
          >
            {hasPermission("orders_tables_print_preparation_table") && (
              <Stack
                direction={shouldStackVertically ? "row" : "row"}
                spacing={{ xs: 1, sm: 1.5, md: 2 }}
                alignItems="center"
                sx={{
                  width: shouldStackVertically ? "100%" : "auto",
                  justifyContent: shouldStackVertically ? "center" : "flex-end",
                  flexWrap: "wrap",
                }}
              >
                <IconButton
                  onClick={(e) => setKitchenMenuAnchor(e.currentTarget)}
                  sx={{
                    background: "linear-gradient(135deg, #fbc2eb 0%, #ff9a9e 100%)",
                    color: "#fff",
                    width: iconSize.width,
                    height: iconSize.height,
                    boxShadow: "0 4px 12px rgba(251, 194, 235, 0.4)",
                    transition: "all 0.3s ease",
                    touchAction: "manipulation",
                    WebkitTapHighlightColor: "transparent",
                    "&:hover": {
                      background: "linear-gradient(135deg, #ff9a9e 0%, #fbc2eb 100%)",
                      transform: "scale(1.1)",
                      boxShadow: "0 6px 20px rgba(251, 194, 235, 0.6)",
                    },
                    "&:active": {
                      transform: "scale(0.95)",
                    },
                  }}
                  size={buttonSize}
                >
                  <KitchenIcon sx={{ fontSize: iconSize.fontSize }} />
                </IconButton>

                <Button
                  variant="contained"
                  onClick={handlePrintPreparation}
                  disabled={!printingEnabled}
                  title="طباعة تجهيز (F9)"
                  size={buttonSize}
                  sx={{
                    background: printingEnabled
                      ? "linear-gradient(135deg, #4caf50 0%, #66bb6a 100%)"
                      : "rgba(200, 200, 200, 0.5)",
                    color: "#fff",
                    borderRadius: { xs: 2, sm: 2.5, md: 3 },
                    px: { xs: 2, sm: 2.5, md: 3 },
                    py: { xs: 0.75, sm: 1, md: 1.25 },
                    fontWeight: 700,
                    fontSize: fontSize.button,
                    boxShadow: printingEnabled
                      ? "0 4px 12px rgba(76, 175, 80, 0.4)"
                      : "none",
                    transition: "all 0.3s ease",
                    touchAction: "manipulation",
                    WebkitTapHighlightColor: "transparent",
                    "&:hover": {
                      background: printingEnabled
                        ? "linear-gradient(135deg, #66bb6a 0%, #4caf50 100%)"
                        : "rgba(200, 200, 200, 0.5)",
                      transform: printingEnabled ? "translateY(-2px)" : "none",
                      boxShadow: printingEnabled
                        ? "0 6px 20px rgba(76, 175, 80, 0.6)"
                        : "none",
                    },
                    "&:active": {
                      transform: "scale(0.98)",
                    },
                    "&:disabled": {
                      background: "rgba(200, 200, 200, 0.3)",
                      color: "rgba(255, 255, 255, 0.4)",
                    },
                  }}
                >
                  {printingEnabled ? "طباعة تجهيز" : "غير متاح"}
                </Button>

                <Menu
                  anchorEl={kitchenMenuAnchor}
                  open={Boolean(kitchenMenuAnchor)}
                  onClose={() => setKitchenMenuAnchor(null)}
                  PaperProps={{
                    sx: {
                      borderRadius: 3,
                      background: "linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)",
                      border: "1px solid rgba(251, 194, 235, 0.2)",
                      boxShadow: "0 8px 32px rgba(0, 0, 0, 0.3)",
                      maxWidth: { xs: "90vw", sm: "400px" },
                    },
                  }}
                >
                  {pendingItems.length > 0 ? (
                    pendingItems.map((item) => (
                      <MenuItem
                        key={item.id}
                        sx={{
                          color: "#fff",
                          fontSize: { xs: 13, sm: 14, md: 15 },
                          py: { xs: 1, sm: 1.25 },
                          px: { xs: 2, sm: 2.5 },
                          transition: "all 0.2s ease",
                          "&:hover": {
                            bgcolor: "rgba(251, 194, 235, 0.1)",
                          },
                        }}
                      >
                        {item.product_name} - الكمية: {item.quantity}
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem
                      sx={{
                        color: "rgba(255, 255, 255, 0.6)",
                        fontSize: { xs: 13, sm: 14, md: 15 },
                        py: { xs: 1, sm: 1.25 },
                        px: { xs: 2, sm: 2.5 },
                        justifyContent: "center",
                      }}
                    >
                      لا توجد أصناف قيد التجهيز
                    </MenuItem>
                  )}
                </Menu>
              </Stack>
            )}
          </Grid>
        </Grid>

        <Box sx={{ mt: spacing }}>
          <OrderItemsList
            items={orderDetails.items.map((item) => ({
              ...item,
              status: item.status || "pending",
            }))}
            onDeleteItem={handleDeleteItem}
            onEditItem={(item) => {
              setSelectedItem(item);
              setItemEditOpen(true);
            }}
            onMoveItem={(item) => {
              setSelectedMoveItem(item);
              setMoveModalOpen(true);
            }}
            tables={tables}
            preparationCasherEnabled={preparationCasherEnabled}
            onPrepareItem={handlePrepareItem}
            changeOrderItemStatus={changeOrderItemStatus}
          />
        </Box>

        <MoveItemModal
          open={moveModalOpen}
          onClose={() => setMoveModalOpen(false)}
          onSubmit={handleMoveItem}
          item={selectedMoveItem}
          tables={tables}
        />

        <EditOrderForm
          open={editOpen}
          onClose={(updatedData) => {
            setEditOpen(false);
            if (updatedData) {
              updateItem(updatedData);
              window.dispatchEvent(
                new CustomEvent("orderUpdated", {
                  detail: { orderId, tableId: orderDetails.table_id },
                })
              );
            }
          }}
          initialData={editData || {}}
        />

        <EditItemModal
          open={itemEditOpen}
          item={selectedItem}
          onClose={() => setItemEditOpen(false)}
        />

        <Snackbar
          open={!!successMsg}
          autoHideDuration={3000}
          onClose={() => setSuccessMsg("")}
          anchorOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
        >
          <Alert
            severity="success"
            sx={{
              width: "100%",
              fontSize: { xs: 13, sm: 14, md: 15 },
              borderRadius: { xs: 2, sm: 2.5, md: 3 },
              boxShadow: "0 4px 16px rgba(76, 175, 80, 0.3)",
            }}
          >
            {successMsg}
          </Alert>
        </Snackbar>
      </Box>
    );
  };

  export default OrderDetailsFetcher;
